import { Controller, useFormContext } from 'react-hook-form'
import { FormInput } from '../../functions/types'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  FormGroup,
  Box,
  FormHelperText,
  Typography,
  Link
} from '@mui/material'
import { useFormStore } from '../../functions/formStore'
import { isNil } from 'lodash/fp'

const InputForm = (): JSX.Element => {
  const {
    formState: { errors },
    control,
    setValue
  } = useFormContext<FormInput>()

  const { setData, data } = useFormStore()
  const optionsNo1: FormInput["No1"] = ["同意する"]

  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography display="flex" justifyContent="center" variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">{`
        ご応募に当たっての同意事項
        `}</Typography>
        <Typography variant="caption" color="black">{`
        キャンペーンへご応募の際は、以下のキャンペーン規約と個人情報保護方針に同意の上、ボタンを押してください。
        `}</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} marginY={3}>
        <FormControl component="fieldset" margin="normal">
          <FormGroup>
            {
              optionsNo1.map((option) => {
                return (
                  <Controller
                    name="No1"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox {...field}
                            checked={data.No1?.includes(option)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                const value = isNil(data.No1) ? [option] : [...data.No1, option]
                                setData({ ...data, No1: value })
                                setValue("No1", value, { shouldValidate: true })
                              } else {
                                const value = isNil(data.No1) ? [] : data.No1.filter((value) => value !== option)
                                setData({ ...data, No1: value })
                                setValue("No1", value, { shouldValidate: true })
                              }
                            }} />
                        }
                        label={<Typography><Link href="https://katene.chuden.jp/clubkatene/p/campaign/kurashi_prj/otoku/tsunagustore-cp/?modal=tsunagustore" target="_blank">キャンペーン規約</Link>と<Link href="https://miraiz.chuden.co.jp/company/privacy/purpose/" target="_blank">個人情報保護方針</Link>に同意する</Typography>}
                      />
                    )}
                  />)
              })}
          </FormGroup>
          <FormHelperText error>{errors.No1?.message}</FormHelperText>
        </FormControl>

      </Box>
    </Box >
  )
}

export default InputForm